<!-- DATES SECTION-->
<div [formGroup]="formStatusDates">
  <div class="mb-3">
    <div class="d-flex">
      <checkbox
        checkedValue="A"
        uncheckedValue="I"
        formControlName="ecsStatus"
        (change)="onStatusChange('ecsDate')"
      >
        ECS
      </checkbox>

      <div class="input-text w-80px ml-auto text-right">
        {{
          (formStatusDates.get('ecsDate')?.value | date: 'MM/dd/yy') || 'N/A'
        }}
      </div>
    </div>
    <div class="d-flex mt-2">
      <checkbox
        checkedValue="A"
        uncheckedValue="I"
        formControlName="eraStatus"
        (change)="onStatusChange('eraDate')"
      >
        ERA
      </checkbox>

      <div class="input-text w-80px ml-auto text-right">
        {{
          (formStatusDates.get('eraDate')?.value | date: 'MM/dd/yy') || 'N/A'
        }}
      </div>
    </div>
    <div class="d-flex mt-2">
      <checkbox
        checkedValue="A"
        uncheckedValue="I"
        formControlName="claimStatusStatus"
        (change)="onStatusChange('claimStatusDate')"
      >
        Claim Status
      </checkbox>

      <div class="input-text w-80px ml-auto text-right">
        {{
          (formStatusDates.get('claimStatusDate')?.value | date: 'MM/dd/yy') ||
            'N/A'
        }}
      </div>
    </div>
    <div class="d-flex mt-2">
      <checkbox
        checkedValue="A"
        uncheckedValue="I"
        formControlName="eligibilityStatus"
        (change)="onStatusChange('eligibilityDate')"
      >
        Eligibility
      </checkbox>

      <div class="input-text w-80px ml-auto text-right">
        {{
          (formStatusDates.get('eligibilityDate')?.value | date: 'MM/dd/yy') ||
            'N/A'
        }}
      </div>
    </div>
    <div class="d-flex mt-2">
      <checkbox
        checkedValue="A"
        uncheckedValue="I"
        formControlName="statementStatus"
        (change)="onStatusChange('statementDate')"
      >
        Statements
      </checkbox>

      <div class="input-text w-80px ml-auto text-right">
        {{
          (formStatusDates.get('statementDate')?.value | date: 'MM/dd/yy') ||
            'N/A'
        }}
      </div>
    </div>
  </div>

  <ng-container *ngIf="isEditMode">
    <div class="row md">
      <div class="col-5">
        <div class="input-label">date setup</div>
        <div class="input-text">
          {{
            (formStatusDates.get('dateSetup')?.value | date: 'MM/dd/yy') ||
              'N/A'
          }}
        </div>
      </div>
      <div class="col-7">
        <div class="input-label">Date terminated</div>

        <div class="input-text">
          {{
            (formStatusDates.get('dateTerminated')?.value | date: 'MM/dd/yy') ||
              'N/A'
          }}
        </div>
      </div>
    </div>
    <div class="row md mt-3">
      <div class="col-5 pr-0">
        <div class="input-label">Last update</div>
        <div class="input-text">
          {{
            (formStatusDates.get('dateLastDbUpdate')?.value ||
              formStatusDates.get('dateLastDbUpdated')?.value
              | date: 'MM/dd/yy') || 'N/A'
          }}
        </div>
      </div>
      <div class="col-7">
        <div class="input-label">last updated by</div>
        <div class="input-text">
          {{
            formStatusDates.get('lastUpdatedBy')?.value ||
              formStatusDates.get('lastDbUpdatedBy')?.value ||
              'N/A'
          }}
        </div>
      </div>
    </div>
  </ng-container>
</div>
